module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("O du")]), _vm._v(" meines Lebens\nLeben! Immer"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nwerd ich mich mühn, rein meinen Leib"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nzu erhalten, wissend, daß auf meinen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nGliedern lebendig dein Hauch ist.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Immer werd ich mich mühn, Unwahres"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nmir fern vom Denken zu halten, wissend:"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndu bist die Wahrheit, die mir im Geiste"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndas Licht der Vernunft entzündet.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Immer werd ich mich mühn, von meinem"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nHerzen die Übel zu treiben und meine"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nLiebe in Blüte zu halten, wissend: du"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nthronest im Allerheiligsten meines Herzens.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Und es soll immer mein Streben sein:"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndich offenbaren in meinem Tun, wissend,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndaß deine Macht mir Kraft gibt zum Handeln. "), _c('a', {
    attrs: {
      "id": "page7",
      "title": "wedi/cal"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0